<template>
  <div>
    <div :class="$style.base">
      <div :class="$style.spinner" />
    </div>
  </div>
</template>

<style module>
.base {
  background: var(--color-white-75);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}

@keyframes spinAround {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg)
  }
}

.spinner {
  box-sizing: border-box;
  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  width: 60px;
  height: 60px;
  border: 8px solid transparent;
  border-top-color: var(--color-pacificblue);
  border-radius: 100%;
  animation: spinAround 0.6s linear infinite;
}
</style>
